<template>
  <div
    class="home1 auth-popup"
    v-if="showSignIn || showSignUp || showForgotPassword"
  >
    <div class="auth-popup-wrapper">
      <Sign-Up
        :validateEmail="validateEmail"
        :validatePassword="validatePassword"
        :setShowSignIn="setShowSignIn"
        :connectWithGoogleAuth="connectWithGoogleAuth"
        :googleAuthLoading="googleAuthLoading"
        :authErrorMsg="authErrorMsg"
        v-if="showSignUp"
      />
      <Sign-In
        :validateEmail="validateEmail"
        :validatePassword="validatePassword"
        :setShowSignUp="setShowSignUp"
        :setShowForgotPassword="setShowForgotPassword"
        :connectWithGoogleAuth="connectWithGoogleAuth"
        :googleAuthLoading="googleAuthLoading"
        :authErrorMsg="authErrorMsg"
        v-if="showSignIn"
      />
      <Forgot-Password
        :validateEmail="validateEmail"
        :setShowSignIn="setShowSignIn"
        v-if="showForgotPassword"
      />
    </div>
    <div class="auth-popup-mask" />
  </div>
</template>

<script>
// @ is an alias to /src
import SignUp from './SignUp'
import SignIn from './SignIn'
import ForgotPassword from './ForgotPassword'
import sharedFunction from './../../assets/util/functions.js'
import { URLS, PAGE_URL } from '@/assets/util/constants/constants.js'
import { post } from '@/assets/util/rest.js'
import { openGoogleAuth } from '../../assets/util/rest'
import { MxEvent } from '../../assets/util/constants/analytics'

export default {
  name: 'AuthenticationView',
  props: ['showPopup'],
  components: {
    'Sign-Up': SignUp,
    'Sign-In': SignIn,
    'Forgot-Password': ForgotPassword
  },
  data: function() {
    return {
      showSignUp: false,
      showSignIn: false,
      showForgotPassword: false,
      emailPreferences: 'true',
      authErrorMsg: '',
      googleAuthLoading: false
    }
  },
  methods: {
    setShowSignUp() {
      this.showSignUp = true
      this.showSignIn = false
      this.showForgotPassword = false
      this.authErrorMsg = ''
    },
    setShowSignIn() {
      this.showSignUp = false
      this.showSignIn = true
      this.showForgotPassword = false
    },
    setShowForgotPassword() {
      this.showSignUp = false
      this.showSignIn = false
      this.showForgotPassword = true
    },
    validateEmailFormat(email) {
      // eslint-disable-next-line no-useless-escape
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    validateEmail(email) {
      if (email === '') {
        return 'Email is required'
      } else {
        if (this.validateEmailFormat(email)) {
          return ''
        } else {
          return 'Enter a valid email'
        }
      }
    },
    validatePassword(password) {
      if (password === '') {
        return 'Password is required'
      } else if (password.length < 6) {
        return 'Password should have at least 6 characters'
      } else {
        return ''
      }
    },
    connectWithGoogleAuth(emailPreferences = true) {
      const thisObj = this
      thisObj.authErrorMsg = ''
      thisObj.emailPreferences = emailPreferences.toString()
      const authCallback = authData => {
        thisObj.googleAuthCallback(authData)
      }
      openGoogleAuth(authCallback)
    },
    googleAuthCallback(authResult) {
      authResult['source'] = 'plugin-li'
      authResult['emailPreferences'] = this.emailPreferences
      var currentTimeInGmt =
        new Date().toString().slice(25, 31) +
        ':' +
        new Date().toString().slice(31, 33)
      authResult['timeZone'] = currentTimeInGmt
      authResult['dataMap'] = {
        pageType: 'linkedin',
        mode: 'Google',
        userEmail: authResult['user_email']
      }
      if (authResult['code'] != undefined && authResult['code'].length > 0) {
        this.sendDataToServer(authResult)
      } else {
        const dataMap = {
          reason: 'Authorisation code from Google server is undefined',
          err: authResult
        }
        sharedFunction.track(MxEvent.googleSignupFailed, dataMap)
      }
    },
    sendDataToServer(authCode) {
      const thisObj = this
      const city = window.localStorage['city']
      const state = window.localStorage['state']
      const country = window.localStorage['country']

      authCode.pageSource = 'Plugin Page'
      authCode.city = city
      authCode.state = state
      authCode.country = country
      this.googleAuthLoading = true

      post(URLS.connectWithGoogle, authCode)
        .then(res => {
          res.json().then(response => {
            if (response['loggedIn'] == 'true') {
              setTimeout(function() {
                window.location.href = PAGE_URL.ONBOARDING
              }, 500)
            } else if (
              response['resultCode'] &&
              response['resultCode'] == '102'
            ) {
              thisObj.authErrorMsg = 'account_not_exist'
            } else {
              thisObj.authErrorMsg = 'Something went wrong try again later'
            }
            thisObj.googleAuthLoading = false
          })
        })
        .catch(() => {
          thisObj.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
.auth-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.auth-popup-wrapper::v-deep {
  width: 90%;
  display: block;
  position: absolute;
  top: 18%;
  margin: 5%;
  z-index: 3;
  border: 1px solid rgba(102, 112, 128, 0.2);
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background-color: #fff;
  min-height: 300px;
  padding: 16px;

  .google-signup {
    background: #fff;
    color: #656565;
    letter-spacing: 0.3px;
    width: 100%;
    text-align: center;
    font-weight: 400;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 3px;
    padding: 5px;
    cursor: pointer;
    line-height: 30px;
    .google-logo {
      max-width: 100%;
      height: 30px;
      vertical-align: middle;
      margin-right: 10px;
    }

    .spinner {
      margin: 0 auto;
    }
  }

  .option-separator {
    width: 90%;
    margin: 0px auto 15px auto;
    padding: 5px 0px;
    position: relative;
    color: #999;
    text-align: center;
    .separator-border {
      position: absolute;
      border-bottom: 1px solid #eee;
      width: 100%;
      left: 0;
      top: 14px;
    }
    .separator-text {
      background: #fff;
      position: relative;
      display: inline-block;
      padding: 0px 15px;
      float: none;
      font-size: 13px;
    }
  }

  .input-wrapper {
    margin-bottom: 15px;

    label {
      font-size: 13px;
      line-height: 20px;
      color: $grey-text;
      margin-bottom: 5px;
      display: block;
    }
    .input-box {
      width: 100%;
      outline: 0;
      background: #ffffff;
      border: 1px solid rgba(102, 112, 128, 0.2);
      box-shadow: none;
      border-radius: 6px;
      padding: 7px 16px;
      font-size: 14px;
      line-height: 22px;
      color: $grey-text;

      &:focus,
      &:focus-visible {
        border: 1px solid $primary-color;
      }
    }

    .error-wrapper {
      margin: 3px 0;
      padding-bottom: 0px;
    }
  }
  .input-wrapper-tel {
    input {
      height: 33px;
    }
    .vue-tel-input {
      border: 1px solid #ccc;
    }
    .vti__dropdown:focus {
      outline: none;
      border: 1px solid #66afe9;
    }
  }
  .error-wrapper {
    color: red;
    padding: 0px;
    font-size: 11px;
    letter-spacing: 0.3px;
    display: block;
    padding-bottom: 10px;
    line-height: 15px;

    a {
      color: #2080ee;
    }
  }

  .action-btn {
    margin-top: 5px;
    width: 100%;
    padding: 10px;
    &:hover {
      background: lighten($color: $primary-color, $amount: 5%);
    }
  }
  .switch-section {
    color: #444;
    letter-spacing: 0.3px;
    font-size: 12px;
    margin: 20px 0 0 0;
    text-align: center;
    .anchor-link {
      font-size: 14px;
      color: $primary-color;
      cursor: pointer;
    }
  }
  .privacy-policy {
    text-align: center;
    color: #444;
    width: 90%;
    position: relative;
    font-size: 13px;
    margin: 12px auto 0;
    line-height: 20px;
    a {
      color: $primary-color;
      font-size: 13px;
      font-weight: 600;
      text-transform: capitalize;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.auth-popup-mask {
  background: rgba(102, 112, 128, 0.3);
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  z-index: 2;
}
</style>
